import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
interface TermsPageProps {
  onNavigate: (page: string) => void;
}
export function TermsPage({
  onNavigate
}: TermsPageProps) {
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-22608">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-22609">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22610">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Пользовательское соглашение'
        }]} className="mb-8" data-id="element-22611" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-22612">
            Пользовательское соглашение
          </h1>
          <p className="text-slate-500" data-id="element-22613">Последнее обновление: 15 мая 2026 г.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-22614">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-22615">
          <h2 data-id="element-22616">1. Предмет соглашения</h2>
          <p data-id="element-22617">
            Настоящее Пользовательское соглашение (далее — «Соглашение»)
            регулирует отношения между сервисом Astriqo (далее — «Сервис») и
            пользователем сети Интернет (далее — «Пользователь»), возникающие
            при использовании Сервиса.
          </p>

          <h2 data-id="element-22618">2. Характер предоставляемых услуг</h2>
          <p data-id="element-22619">
            Сервис предоставляет информационно-развлекательные услуги в сфере
            астрологии. Все генерируемые отчеты, прогнозы и консультации носят
            рекомендательный характер. Сервис не несет ответственности за
            решения, принятые Пользователем на основе полученной информации.
          </p>
          <p data-id="element-22620">
            <strong data-id="element-22621">Важно:</strong> Астрологические консультации и отчеты не
            заменяют профессиональную медицинскую, психологическую, юридическую
            или финансовую помощь.
          </p>

          <h2 data-id="element-22622">3. Регистрация и аккаунт</h2>
          <p data-id="element-22623">
            Для доступа к полному функционалу Сервиса Пользователь должен пройти
            процедуру регистрации. Пользователь обязуется предоставить
            достоверную информацию о себе и несет ответственность за сохранность
            своих данных для входа (логин и пароль).
          </p>

          <h2 data-id="element-22624">4. Оплата и возврат средств</h2>
          <p data-id="element-22625">
            Оплата услуг (Premium-отчеты, консультации) производится на условиях
            100% предоплаты. Поскольку автоматические отчеты являются цифровым
            контентом, доступ к которому предоставляется мгновенно, возврат
            средств за них по умолчанию не производится (в соответствии с
            законодательством о защите прав потребителей).
          </p>
          <p data-id="element-22626">
            Возврат средств за консультацию с астрологом возможен при отмене не
            позднее чем за 24 часа до назначенного времени.
          </p>

          <h2 data-id="element-22627">5. Правила поведения на платформе</h2>
          <p data-id="element-22628">Пользователю запрещается:</p>
          <ul data-id="element-22629">
            <li data-id="element-22630">
              Использовать нецензурную лексику и оскорбления при общении с
              астрологами или службой поддержки.
            </li>
            <li data-id="element-22631">
              Копировать, распространять или перепродавать материалы Сервиса
              (отчеты, статьи) без письменного разрешения.
            </li>
            <li data-id="element-22632">
              Использовать автоматизированные скрипты (боты) для сбора
              информации с Сервиса.
            </li>
          </ul>

          <h2 data-id="element-22633">6. Ограничение ответственности</h2>
          <p data-id="element-22634">
            Сервис предоставляется «как есть» (as is). Мы не гарантируем, что
            Сервис будет соответствовать вашим требованиям, будет
            предоставляться непрерывно, быстро, надежно и без ошибок.
          </p>

          <h2 data-id="element-22635">7. Изменение условий</h2>
          <p data-id="element-22636">
            Администрация Сервиса оставляет за собой право вносить изменения в
            настоящее Соглашение в любой момент. Продолжение использования
            Сервиса после внесения изменений означает согласие Пользователя с
            новой редакцией Соглашения.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-22637">
          <button onClick={() => onNavigate('privacy')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-22638">
            Политика конфиденциальности →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-22639">
            Есть вопросы? Свяжитесь с нами
          </button>
        </div>
      </div>
    </div>;
}